export enum BORD_UPLOADER_BUTTON_TYPE {
  ERROR = 'error',
  DEFAULT = 'default',
  DISABLED = 'disabled'
}

export enum ACCEPTED_FILE_EXTENSION {
  DOC = '.doc',
  DOCX = '.docx',
  PDF = '.pdf',
  PNG = '.png',
  JPG = '.jpg',
  JPEG = '.jpeg',
  XLS = '.xls',
  XLSX = '.xlsx',
  ALL = '*'
}

export enum ICON_VARIANT {
  DOWNLOAD = 'download',
  TRASH = 'trash',
  UPLOAD = 'upload'
}

export interface IDocumentDetail {
  documentName: string | JSX.Element;
  name?: string;
  documentFile?: File;
  url?: string;
}

export interface IBordUploaderButton {
  label?: string;
  isFilled?: boolean;
  bordUploaderButtonType?: BORD_UPLOADER_BUTTON_TYPE;
  disabledBordUploaderButton?: boolean;
  loading?: boolean;
  errorText?: string;
  title?: string | JSX.Element;
  emptyBordUploaderButtonTitle?: string;
  emptyBordUploaderButtonSubtitle?: string;
  defaultFile?: IDocumentDetail;
  handleChangeFile?: (file: File) => void;
  handleDeleteFile?: () => void;
  handleDownloadFile?: (url: string) => void;
  customWidth?: string;
  defaultWidthFull?: boolean;
  modeReplaceFile?: boolean;
  acceptFileExtension?: ACCEPTED_FILE_EXTENSION[];
  customClassName?: string;
  customContainerClassName?: string;
  customFileNameClass?: string;
  iconsCustomWidth?: string;
  standardSize?: 8 | 10 | 12 | 14 | 16 | 20 | 24 | 32;
}
